(function () {
  function parseConfig(root) {
    const configEl = root.querySelector('[data-mcp-tiers-config]');
    if (!configEl) return null;
    try {
      return JSON.parse(configEl.textContent);
    } catch {
      return null;
    }
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) + ' €';
  }

  function initGallery(root) {
    const stage = root.querySelector('[data-gallery-stage]');
    const thumbs = root.querySelector('[data-gallery-thumbs]');
    const prevBtn = root.querySelector('[data-gallery-prev]');
    const nextBtn = root.querySelector('[data-gallery-next]');
    const gallery = root.querySelector('[data-product-gallery]');

    let index = 0;
    let startX = 0;

    function slides() {
      return [...root.querySelectorAll('[data-gallery-slide]')];
    }

    function dots() {
      return [...root.querySelectorAll('[data-gallery-dot]')];
    }

    function showSlide(nextIndex) {
      const all = slides();
      if (!all.length) return;
      index = (nextIndex + all.length) % all.length;
      all.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      dots().forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    }

    function bindNav() {
      if (prevBtn && !prevBtn.dataset.bound) {
        prevBtn.dataset.bound = 'true';
        prevBtn.addEventListener('click', () => showSlide(index - 1));
      }
      if (nextBtn && !nextBtn.dataset.bound) {
        nextBtn.dataset.bound = 'true';
        nextBtn.addEventListener('click', () => showSlide(index + 1));
      }
      if (gallery && !gallery.dataset.swipeBound) {
        gallery.dataset.swipeBound = 'true';
        gallery.addEventListener(
          'touchstart',
          (event) => {
            startX = event.changedTouches[0].screenX;
          },
          { passive: true }
        );
        gallery.addEventListener(
          'touchend',
          (event) => {
            const delta = event.changedTouches[0].screenX - startX;
            if (Math.abs(delta) < 40) return;
            showSlide(index + (delta < 0 ? 1 : -1));
          },
          { passive: true }
        );
      }
    }

    function render(images) {
      if (!stage || !Array.isArray(images) || images.length === 0) return;
      stage.querySelectorAll('[data-gallery-slide]').forEach((el) => el.remove());
      images.forEach((image, i) => {
        const slide = document.createElement('div');
        slide.className = 'mcp-pdp__slide' + (i === 0 ? ' is-active' : '');
        slide.setAttribute('data-gallery-slide', '');
        const img = document.createElement('img');
        img.className = 'mcp-pdp__image';
        img.src = image.src;
        img.alt = image.alt || '';
        img.width = 1200;
        img.height = 1200;
        img.loading = i === 0 ? 'eager' : 'lazy';
        slide.appendChild(img);
        const navPrev = stage.querySelector('[data-gallery-prev]');
        if (navPrev) stage.insertBefore(slide, navPrev);
        else stage.appendChild(slide);
      });

      if (thumbs) {
        thumbs.innerHTML = '';
        images.forEach((image, i) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'mcp-pdp__thumb' + (i === 0 ? ' is-active' : '');
          btn.setAttribute('data-gallery-dot', String(i));
          btn.setAttribute('aria-label', 'Voir l’image ' + (i + 1));
          btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
          btn.innerHTML =
            '<span class="mcp-pdp__thumb-media"><img src="' +
            (image.thumb || image.src) +
            '" alt="" width="80" height="80" loading="lazy"></span>';
          btn.addEventListener('click', () => showSlide(i));
          thumbs.appendChild(btn);
        });
        thumbs.hidden = images.length <= 1;
      }

      const many = images.length > 1;
      if (prevBtn) prevBtn.hidden = !many;
      if (nextBtn) nextBtn.hidden = !many;
      index = 0;
      bindNav();
    }

    bindNav();
    dots().forEach((dot) => {
      dot.addEventListener('click', () => showSlide(Number(dot.dataset.galleryDot) || 0));
    });

    return { render, showSlide };
  }

  function initStepper(root, getUnitCents) {
    const stepper = root.querySelector('[data-quantity-stepper]');
    const input = root.querySelector('[data-quantity-input]');
    const totalPriceEl = root.querySelector('[data-total-price]');
    if (!stepper || !input) return function () {};

    function updateTotal() {
      const qty = parseInt(input.value, 10) || 1;
      if (totalPriceEl) totalPriceEl.textContent = formatMoney(getUnitCents() * qty);
    }

    const decreaseBtn = stepper.querySelector('[data-quantity-decrease]');
    const increaseBtn = stepper.querySelector('[data-quantity-increase]');
    if (decreaseBtn) {
      decreaseBtn.addEventListener('click', () => {
        input.value = String(Math.max(1, (parseInt(input.value, 10) || 1) - 1));
        updateTotal();
      });
    }
    if (increaseBtn) {
      increaseBtn.addEventListener('click', () => {
        input.value = String((parseInt(input.value, 10) || 1) + 1);
        updateTotal();
      });
    }
    input.addEventListener('input', () => {
      if (parseInt(input.value, 10) < 1 || !input.value) input.value = '1';
      updateTotal();
    });

    return updateTotal;
  }

  function showJudgemeTier(tierId) {
    // Avec le bloc app Judge.me natif : navigation douce vers l’URL du format
    // pour charger les bons avis (évite de détruire le widget).
    // Les panneaux data-judgeme-tier restent supportés si présents.
    const panels = document.querySelectorAll('[data-judgeme-tier]');
    if (!panels.length) return;

    panels.forEach((panel) => {
      const active = panel.getAttribute('data-judgeme-tier') === tierId;
      panel.hidden = !active;
    });
  }

  function updateBuyRating(root, tier) {
    const ratingEl = root.querySelector('[data-product-rating]');
    const row = root.querySelector('[data-product-rating-row]');
    if (!ratingEl) return;

    const count = Number(tier.reviewCount) || 0;
    const rating = Number(tier.rating) || 0;
    const starsEl = ratingEl.querySelector('[data-product-rating-stars]');
    const textEl = ratingEl.querySelector('[data-product-rating-text]');
    const badge = ratingEl.querySelector('.jdgm-preview-badge');

    if (starsEl && textEl) {
      if (count > 0) {
        const stars = Math.max(1, Math.min(5, Math.round(rating > 0 ? rating : 5)));
        starsEl.textContent = '★'.repeat(stars);
        textEl.textContent = (rating > 0 ? rating : 5).toFixed(1) + '/5 · ' + count + ' avis';
        ratingEl.hidden = false;
        ratingEl.classList.remove('is-hidden');
        if (row) row.style.display = '';
      } else {
        ratingEl.hidden = true;
        ratingEl.classList.add('is-hidden');
        if (row) row.style.display = 'none';
      }
      return;
    }

    if (badge && tier.productId) {
      badge.setAttribute('data-id', String(tier.productId));
      badge.setAttribute('data-product-id', String(tier.productId));
      if (count <= 0 && row) {
        /* laisse Judge.me masquer si 0 avis après reload */
      }
    }
  }

  function initProductFormat(root) {
    const config = parseConfig(root);
    const variantInput = root.querySelector('[data-variant-input]');
    const addButton = root.querySelector('[data-add-button]');
    const addLabelEl = root.querySelector('[data-add-label]');
    const priceEl = root.querySelector('[data-unit-price]');
    const compareEl = root.querySelector('[data-compare-price]');
    const discountEl = root.querySelector('[data-discount-badge]');
    const descEl = root.querySelector('[data-product-desc]');
    const guestsEl = root.querySelector('[data-highlight-guests]');
    const piecesEl = root.querySelector('[data-highlight-pieces]');
    const detailsImage = root.querySelector('.mcp-pdp-details__image:not(.mcp-pdp-details__image--grid)');
    const detailsSplit = root.querySelector('[data-details-split]');
    const offerButtons = [...root.querySelectorAll('[data-format-option]')];
    const gallery = initGallery(root);

    let unitCents = priceEl ? parseInt(priceEl.dataset.cents || '0', 10) : 0;
    const updateTotal = initStepper(root, () => unitCents);

    if (!config || !variantInput || offerButtons.length === 0) return;

    const addLabel = config.addLabel || 'Ajouter au panier';
    const soldOutLabel = config.soldOutLabel || 'Indisponible';
    let activeTierId = config.currentTier || 'essentielle';

    function selectTier(tierId, updateUrl, skipGalleryRender) {
      const tier = config.tiers?.[tierId];
      if (!tier) return;

      const tierChanged = activeTierId !== tierId;
      activeTierId = tierId;

      variantInput.value = String(tier.variantId);
      unitCents = Number(tier.priceCents) || 0;

      if (priceEl) {
        priceEl.textContent = tier.priceFormatted;
        priceEl.dataset.cents = String(unitCents);
      }
      updateTotal();

      const compareCents = Number(tier.compareCents) || 0;
      if (compareEl) {
        if (compareCents > unitCents && tier.compareFormatted) {
          compareEl.textContent = tier.compareFormatted;
          compareEl.classList.remove('is-hidden');
        } else {
          compareEl.textContent = '';
          compareEl.classList.add('is-hidden');
        }
      }
      if (discountEl) {
        if (compareCents > unitCents) {
          const pct = Math.round(((compareCents - unitCents) * 100) / compareCents);
          discountEl.textContent = pct + '% de réduction';
          discountEl.classList.remove('is-hidden');
        } else {
          discountEl.textContent = '';
          discountEl.classList.add('is-hidden');
        }
      }

      if (descEl && tier.description) descEl.textContent = tier.description;

      if (guestsEl) guestsEl.textContent = tier.guests + ' invités';
      if (piecesEl && tier.accessoryCount) piecesEl.textContent = tier.accessoryCount + ' pièces';

      offerButtons.forEach((btn) => {
        const active = btn.dataset.formatOption === tierId;
        btn.classList.toggle('is-selected', active);
        btn.classList.toggle('mcp-format-compare--current', active);
        btn.setAttribute('aria-checked', active ? 'true' : 'false');
        btn.setAttribute('aria-current', active ? 'true' : 'false');
        const cta = btn.querySelector('.mcp-format-compare__cta');
        if (cta) {
          cta.textContent = active ? 'Sélectionné' : 'Choisir';
          cta.classList.toggle('mcp-format-compare__cta--current', active);
        }
      });

      if (addButton && addLabelEl) {
        if (tier.available) {
          addButton.disabled = false;
          addLabelEl.textContent = addLabel;
        } else {
          addButton.disabled = true;
          addLabelEl.textContent = soldOutLabel;
        }
      }

      if (tier.gallery && gallery.render && !skipGalleryRender) gallery.render(tier.gallery);

      if (detailsImage && !detailsSplit) {
        const staticSrc = detailsImage.dataset.detailsSrc;
        if (staticSrc) {
          detailsImage.src = staticSrc;
        } else if (tier.gallery && tier.gallery[0]) {
          detailsImage.src = tier.gallery[0].src;
        }
      }

      root.querySelectorAll('[data-includes-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.includesPanel !== tierId;
      });

      root.querySelectorAll('[data-dimensions-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.dimensionsPanel !== tierId;
      });

      root.dataset.currentTier = tierId;
      updateBuyRating(root, tier);
      showJudgemeTier(tierId);

      // Bloc app Judge.me = 1 produit par page. Pour les bons avis, on recharge
      // la page du format choisi (photos/prix restent instantanés jusqu’au reload).
      if (updateUrl !== false && tierChanged && tier.url) {
        window.location.assign(tier.url);
        return;
      }

      if (updateUrl !== false && tier.url) {
        window.history.replaceState({}, '', tier.url);
      }
    }

    offerButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        selectTier(btn.dataset.formatOption, true);
      });
    });

    selectTier(config.currentTier || 'essentielle', false, true);
  }

  document.querySelectorAll('[data-main-product-mcp]').forEach((root) => {
    initProductFormat(root);
  });
})();

